
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [email, setEmail] = useState('');

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-white/10">
        <div className="w-full px-8 h-20">
          <div className="flex items-center justify-between h-full">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/571bb13994f5d3422b93d5f90aef5694/9d5360e216fd1546f3a3cf25996642e6.png" 
                alt="Dotescom Ventures Logo" 
                className="h-12 w-auto object-contain"
              />
            </Link>
            
            <div className="flex items-center gap-8">
              <a href="#home" className="text-white text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">HOME</a>
              <a href="#shop" className="text-white text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">SHOP</a>
              <a href="#gallery" className="text-white text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">3D GALLERY</a>
              <a href="#about" className="text-white text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">ABOUT US</a>
              <a href="#contact" className="text-white text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">CONTACT</a>
              <a href="#faq" className="text-white text-sm font-medium hover:text-cyan-400 transition-colors whitespace-nowrap cursor-pointer">FAQ</a>
            </div>

            <div className="flex items-center gap-6">
              <button className="text-white hover:text-cyan-400 transition-colors cursor-pointer" aria-label="Search">
                <i className="ri-search-line text-xl"></i>
              </button>
              <button className="text-white hover:text-cyan-400 transition-colors relative cursor-pointer" aria-label="Shopping Cart">
                <i className="ri-shopping-cart-line text-xl"></i>
                <span className="absolute -top-2 -right-2 bg-cyan-400 text-black text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">3</span>
              </button>
              <button className="text-white hover:text-cyan-400 transition-colors cursor-pointer" aria-label="User Profile">
                <i className="ri-user-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center pt-20">
        <div className="w-full flex">
          {/* Left Content */}
          <div className="w-2/5 bg-gradient-to-br from-black via-purple-950 to-black flex items-center justify-center px-12">
            <div className="max-w-xl">
              <div className="inline-block px-6 py-2 rounded-full bg-cyan-400/20 border border-cyan-400 mb-8">
                <span className="text-cyan-400 text-sm font-semibold tracking-wider">NEW COLLECTION 2025</span>
              </div>
              
              <h1 className="text-7xl font-bold text-white mb-6 leading-tight">
                DIGITAL<br />3D ASSETS
              </h1>
              
              <p className="text-2xl text-gray-300 mb-12 leading-relaxed">
                Premium quality 3D models for creators and developers
              </p>
              
              <div className="flex gap-4">
                <a href="#shop" className="px-8 py-4 bg-white text-black rounded-2xl font-semibold hover:bg-gray-100 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer">
                  EXPLORE SHOP
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="#gallery" className="px-8 py-4 bg-transparent border-2 border-cyan-400 text-cyan-400 rounded-2xl font-semibold hover:bg-cyan-400 hover:text-black transition-all whitespace-nowrap cursor-pointer">
                  VIEW GALLERY
                </a>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="w-3/5 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/e7e74907005ead2c6faa7146ee17a252.jpg"
                  alt="3D Digital Asset"
                  className="w-96 h-96 object-contain animate-float"
                />
                <div className="absolute inset-0 bg-gradient-radial from-cyan-500/20 via-purple-500/10 to-transparent blur-3xl"></div>
              </div>
            </div>
            
            {/* Floating particles */}
            <div className="absolute top-20 left-20 w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
            <div className="absolute top-40 right-32 w-3 h-3 bg-purple-400 rounded-full animate-pulse delay-100"></div>
            <div className="absolute bottom-32 left-40 w-2 h-2 bg-cyan-400 rounded-full animate-pulse delay-200"></div>
            <div className="absolute bottom-20 right-20 w-3 h-3 bg-purple-400 rounded-full animate-pulse delay-300"></div>
          </div>
        </div>
      </section>

      {/* Shop Section */}
      <section id="shop" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-8">
          <h2 className="text-5xl font-bold text-black mb-12">FEATURED 3D PRODUCTS</h2>
          
          <div className="grid grid-cols-3 gap-6">
            {[
              {
                title: 'Futuristic Sci-Fi Character',
                price: '$149',
                image: 'https://readdy.ai/api/search-image?query=professional%20high%20quality%20futuristic%20sci-fi%20character%203D%20model%20with%20armor%20and%20weapons%20on%20simple%20clean%20white%20studio%20background%20premium%20digital%20asset%20for%20game%20development&width=600&height=400&seq=product001&orientation=landscape',
                category: 'Characters'
              },
              {
                title: 'Modern Architecture Pack',
                price: '$199',
                image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20architecture%20building%203D%20model%20collection%20with%20clean%20lines%20and%20glass%20materials%20on%20simple%20white%20studio%20background%20premium%20digital%20asset%20pack&width=600&height=400&seq=product002&orientation=landscape',
                category: 'Architecture'
              },
              {
                title: 'Organic Nature Assets',
                price: '$89',
                image: 'https://readdy.ai/api/search-image?query=realistic%20organic%20nature%203D%20models%20trees%20plants%20rocks%20vegetation%20on%20simple%20clean%20white%20studio%20background%20premium%20digital%20asset%20collection%20for%20environment%20design&width=600&height=400&seq=product003&orientation=landscape',
                category: 'Nature'
              },
              {
                title: 'Cyberpunk Vehicle Set',
                price: '$249',
                image: 'https://readdy.ai/api/search-image?query=cyberpunk%20futuristic%20vehicle%203D%20model%20with%20neon%20lights%20and%20advanced%20technology%20on%20simple%20dark%20studio%20background%20premium%20digital%20asset%20for%20sci-fi%20projects&width=600&height=400&seq=product004&orientation=landscape',
                category: 'Vehicles'
              },
              {
                title: 'Fantasy Weapon Collection',
                price: '$129',
                image: 'https://readdy.ai/api/search-image?query=fantasy%20medieval%20weapons%203D%20models%20swords%20axes%20shields%20with%20magical%20effects%20on%20simple%20clean%20studio%20background%20premium%20digital%20asset%20collection&width=600&height=400&seq=product005&orientation=landscape',
                category: 'Props'
              },
              {
                title: 'Interior Design Bundle',
                price: '$179',
                image: 'https://readdy.ai/api/search-image?query=modern%20interior%20design%20furniture%203D%20models%20chairs%20tables%20lamps%20decorations%20on%20simple%20white%20studio%20background%20premium%20digital%20asset%20bundle&width=600&height=400&seq=product006&orientation=landscape',
                category: 'Furniture'
              }
            ].map((product, index) => (
              <div 
                key={index}
                className="group relative bg-white rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-500 hover:scale-105 cursor-pointer"
                data-product-shop
              >
                <div className="relative aspect-[16/9] overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                  
                  <div className="absolute top-4 right-4">
                    <span className="px-4 py-2 bg-cyan-400 text-black rounded-full font-bold text-sm">
                      {product.price}
                    </span>
                  </div>

                  <div className="absolute top-4 left-4 opacity-0 group-hover:opacity-100 transition-opacity">
                    <button className="w-10 h-10 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center text-white hover:bg-white hover:text-black transition-colors">
                      <i className="ri-eye-line"></i>
                    </button>
                  </div>
                  
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <span className="text-cyan-400 text-sm font-semibold mb-2 block">{product.category}</span>
                    <h3 className="text-xl font-bold text-white mb-2">{product.title}</h3>
                    <p className="text-gray-300 text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                      High-quality 3D model ready for your projects
                    </p>
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <button className="w-full py-4 bg-black text-white font-semibold hover:bg-gray-900 transition-colors whitespace-nowrap">
                    ADD TO CART
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3D Gallery Section */}
      <section id="gallery" className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-8">
          <h2 className="text-6xl font-bold text-white text-center mb-12">EXPLORE 3D GALLERY</h2>
          
          <div className="flex justify-center gap-4 mb-12">
            {['All', 'Characters', 'Environments', 'Props', 'Vehicles', 'Architecture'].map((filter) => (
              <button 
                key={filter}
                className="px-6 py-2 rounded-full border border-white text-white hover:bg-cyan-400 hover:border-cyan-400 hover:text-black transition-all whitespace-nowrap cursor-pointer"
              >
                {filter}
              </button>
            ))}
          </div>

          <div className="columns-4 gap-4 space-y-4">
            {[
              { title: 'Cyberpunk City', category: 'Environment', height: 'h-80', image: 'https://readdy.ai/api/search-image?query=cyberpunk%20futuristic%20city%20environment%203D%20render%20with%20neon%20lights%20skyscrapers%20and%20flying%20vehicles%20dark%20atmospheric%20lighting%20premium%20digital%20art%20simple%20clean%20composition&width=400&height=500&seq=gallery001&orientation=portrait' },
              { title: 'Warrior Character', category: 'Character', height: 'h-96', image: 'https://readdy.ai/api/search-image?query=epic%20fantasy%20warrior%20character%203D%20model%20with%20detailed%20armor%20and%20weapons%20heroic%20pose%20on%20simple%20dark%20background%20premium%20digital%20asset&width=400&height=600&seq=gallery002&orientation=portrait' },
              { title: 'Sci-Fi Weapon', category: 'Props', height: 'h-72', image: 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20energy%20weapon%203D%20model%20with%20glowing%20elements%20and%20advanced%20technology%20on%20simple%20dark%20background%20premium%20digital%20asset&width=400&height=450&seq=gallery003&orientation=portrait' },
              { title: 'Modern Building', category: 'Architecture', height: 'h-88', image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20architecture%20building%203D%20render%20with%20glass%20and%20concrete%20materials%20clean%20design%20on%20simple%20background%20premium%20digital%20visualization&width=400&height=550&seq=gallery004&orientation=portrait' },
              { title: 'Fantasy Dragon', category: 'Character', height: 'h-80', image: 'https://readdy.ai/api/search-image?query=majestic%20fantasy%20dragon%20creature%203D%20model%20with%20detailed%20scales%20and%20wings%20flying%20pose%20on%20simple%20dark%20background%20premium%20digital%20asset&width=400&height=500&seq=gallery005&orientation=portrait' },
              { title: 'Space Station', category: 'Environment', height: 'h-96', image: 'https://readdy.ai/api/search-image?query=futuristic%20space%20station%203D%20environment%20with%20modular%20design%20and%20technology%20elements%20floating%20in%20space%20simple%20clean%20background%20premium%20digital%20asset&width=400&height=600&seq=gallery006&orientation=portrait' },
              { title: 'Racing Vehicle', category: 'Vehicle', height: 'h-72', image: 'https://readdy.ai/api/search-image?query=futuristic%20racing%20vehicle%203D%20model%20with%20aerodynamic%20design%20and%20neon%20accents%20on%20simple%20dark%20studio%20background%20premium%20digital%20asset&width=400&height=450&seq=gallery007&orientation=portrait' },
              { title: 'Magic Staff', category: 'Props', height: 'h-88', image: 'https://readdy.ai/api/search-image?query=fantasy%20magic%20staff%203D%20model%20with%20glowing%20crystals%20and%20ornate%20details%20on%20simple%20dark%20background%20premium%20digital%20asset%20for%20games&width=400&height=550&seq=gallery008&orientation=portrait' }
            ].map((item, index) => (
              <div 
                key={index}
                className={`group relative ${item.height} rounded-2xl overflow-hidden cursor-pointer break-inside-avoid`}
              >
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/30 via-purple-500/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity border-2 border-transparent group-hover:border-cyan-400 rounded-2xl"></div>
                
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-white/20 backdrop-blur-md rounded-full text-white text-xs font-semibold">
                    {item.category}
                  </span>
                </div>

                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <button className="px-6 py-3 bg-white text-black rounded-full font-semibold hover:bg-cyan-400 transition-colors whitespace-nowrap">
                    View in 3D
                  </button>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform">
                  <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
                  <div className="flex items-center gap-4 text-white/80 text-sm">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> 1.2k
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line"></i> 234
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="py-24 bg-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 opacity-10">
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <path d="M 20 100 Q 60 20, 100 100 T 180 100" stroke="#000" fill="none" strokeWidth="2"/>
          </svg>
        </div>

        <div className="max-w-7xl mx-auto px-8">
          <div className="flex items-center gap-12">
            <div className="w-2/5 relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20creative%20digital%20studio%20workspace%20with%203D%20designers%20working%20on%20computers%20and%20holographic%20displays%20professional%20team%20environment%20clean%20bright%20lighting%20technology%20innovation&width=600&height=700&seq=aboutus001&orientation=portrait"
                  alt="Dotescom Ventures Team"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="w-3/5 bg-black rounded-3xl p-16 relative">
              <div className="absolute top-8 left-8 text-amber-100 opacity-20">
                <i className="ri-double-quotes-l text-6xl"></i>
              </div>

              <div className="relative z-10">
                <span className="text-gray-400 text-sm font-semibold tracking-widest mb-4 block">OUR STORY</span>
                <h2 className="text-5xl font-bold text-white mb-6 leading-tight">
                  CRAFTING DIGITAL<br />EXCELLENCE
                </h2>
                <p className="text-gray-300 text-lg leading-relaxed mb-8">
                  At Dotescom Ventures, we're passionate about creating premium 3D digital assets that empower creators, developers, and businesses worldwide. Our team of expert 3D artists and designers work tirelessly to deliver exceptional quality and innovation in every project.
                </p>
                <p className="text-gray-300 text-lg leading-relaxed mb-12">
                  With years of experience in the digital asset industry, we've built a reputation for excellence, reliability, and cutting-edge design. Our mission is to make professional 3D content accessible to everyone.
                </p>

                <div className="mb-12">
                  <p className="text-white text-xl font-semibold">Michael Dotescom</p>
                  <p className="text-gray-400">Founder & Creative Director</p>
                </div>

                <button className="px-8 py-4 bg-pink-300 text-black rounded-full font-semibold hover:bg-pink-400 transition-colors whitespace-nowrap cursor-pointer">
                  Learn More About Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="relative py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=abstract%20futuristic%20digital%20technology%20background%20with%20purple%20and%20black%20gradient%20geometric%20patterns%20and%20glowing%20elements%20modern%20minimalist%20design%20for%20contact%20section&width=1920&height=800&seq=contact001&orientation=landscape"
            alt="Contact Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-purple-900/70 via-black/60 to-black/70"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-8">
          <div className="flex items-end justify-between">
            <div>
              <h2 className="text-7xl font-bold text-white mb-6 tracking-wide lowercase">
                LET'S CREATE<br />TOGETHER
              </h2>
            </div>

            <div className="text-right mb-8">
              <p className="text-white text-xl font-light leading-relaxed">
                Get in touch with our team<br />
                We're here to help you succeed
              </p>
            </div>
          </div>

          <div className="mt-16">
            <a 
              href="mailto:info@dotescomventures.com"
              className="inline-flex items-center gap-4 px-12 py-6 bg-white text-black rounded-full font-semibold text-lg hover:scale-105 transition-transform whitespace-nowrap cursor-pointer group"
            >
              CONTACT US
              <span className="w-12 h-12 bg-black rounded-full flex items-center justify-center text-white group-hover:bg-cyan-400 group-hover:text-black transition-colors">
                <i className="ri-arrow-right-line text-xl"></i>
              </span>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-8">
          <h2 className="text-5xl font-bold text-black text-center mb-16">FREQUENTLY ASKED QUESTIONS</h2>

          <div className="space-y-4">
            {[
              {
                question: 'What file formats do you provide for 3D models?',
                answer: 'We provide our 3D models in multiple industry-standard formats including FBX, OBJ, GLTF, and Blender files. Each purchase includes all available formats for maximum compatibility with your workflow.'
              },
              {
                question: 'Can I use these assets for commercial projects?',
                answer: 'Yes! All our 3D assets come with a commercial license that allows you to use them in your commercial projects, games, films, and applications. The license is included with every purchase.'
              },
              {
                question: 'Do you offer custom 3D modeling services?',
                answer: 'Absolutely! Our team of expert 3D artists can create custom models tailored to your specific needs. Contact us with your project requirements, and we\'ll provide a detailed quote and timeline.'
              },
              {
                question: 'What is your refund policy?',
                answer: 'We offer a 30-day money-back guarantee on all purchases. If you\'re not satisfied with your 3D asset for any reason, contact our support team within 30 days for a full refund.'
              },
              {
                question: 'How do I download my purchased assets?',
                answer: 'After completing your purchase, you\'ll receive an email with download links to all your assets. You can also access your purchases anytime from your account dashboard on our website.'
              },
              {
                question: 'Do you provide technical support?',
                answer: 'Yes! We offer comprehensive technical support for all our products. Our support team is available via email and live chat to help you with any questions or issues you may encounter.'
              }
            ].map((faq, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="text-xl font-semibold text-black pr-8">{faq.question}</span>
                  <span className={`w-10 h-10 flex items-center justify-center rounded-full bg-cyan-400 text-black flex-shrink-0 transition-transform ${openFaq === index ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-xl"></i>
                  </span>
                </button>
                
                <div 
                  className={`overflow-hidden transition-all duration-300 ${openFaq === index ? 'max-h-96' : 'max-h-0'}`}
                >
                  <div className="px-8 pb-6 pt-2">
                    <p className="text-gray-600 text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-emerald-950 text-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-8 py-16">
          <div className="grid grid-cols-4 gap-12 mb-16">
            {/* Brand Column */}
            <div>
              <img 
                src="https://static.readdy.ai/image/571bb13994f5d3422b93d5f90aef5694/9d5360e216fd1546f3a3cf25996642e6.png" 
                alt="Dotescom Ventures" 
                className="h-12 w-auto mb-6"
              />
              <p className="text-gray-300 text-sm leading-relaxed">
                Premium 3D digital assets for creators, developers, and businesses worldwide. Quality you can trust.
              </p>
            </div>

            {/* Newsletter Column */}
            <div>
              <h3 className="text-xs font-semibold text-gray-400 tracking-widest mb-6">STAY UPDATED</h3>
              <form onSubmit={handleNewsletterSubmit} className="mb-4">
                <div className="relative">
                  <input 
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email address"
                    className="w-full bg-transparent border-b border-gray-500 py-3 pr-12 text-white placeholder-gray-500 focus:border-cyan-400 focus:outline-none transition-colors"
                    required
                  />
                  <button 
                    type="submit"
                    className="absolute right-0 top-1/2 -translate-y-1/2 text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-line text-xl"></i>
                  </button>
                </div>
              </form>
              <a href="#" className="text-xs text-gray-400 hover:text-white transition-colors underline cursor-pointer">
                Privacy Policy
              </a>
            </div>

            {/* Quick Links Column */}
            <div>
              <h3 className="text-xs font-semibold text-gray-400 tracking-widest mb-6">QUICK LINKS</h3>
              <div className="space-y-4">
                <a href="#shop" className="block text-white hover:text-cyan-400 transition-colors cursor-pointer">Shop</a>
                <a href="#gallery" className="block text-white hover:text-cyan-400 transition-colors cursor-pointer">3D Gallery</a>
                <a href="#about" className="block text-white hover:text-cyan-400 transition-colors cursor-pointer">About Us</a>
              </div>
            </div>

            {/* Social Column */}
            <div>
              <h3 className="text-xs font-semibold text-gray-400 tracking-widest mb-6">FOLLOW US</h3>
              <div className="space-y-4">
                <a href="#" className="block text-white hover:text-cyan-400 transition-colors cursor-pointer">Instagram</a>
                <a href="#" className="block text-white hover:text-cyan-400 transition-colors cursor-pointer">Twitter</a>
                <a href="#" className="block text-white hover:text-cyan-400 transition-colors cursor-pointer">LinkedIn</a>
              </div>
            </div>
          </div>

          {/* Large Brand Typography */}
          <div className="relative py-12 border-t border-white/10">
            <div className="text-center">
              <h2 className="text-8xl font-bold text-amber-100/10 tracking-tight">DOTESCOM</h2>
            </div>
          </div>

          {/* Copyright */}
          <div className="text-center text-gray-400 text-sm pt-8 border-t border-white/10">
            <p>© 2025 Dotescom Ventures. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .delay-100 { animation-delay: 0.1s; }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
      `}</style>
    </div>
  );
}
